import { makeStyles } from '@material-ui/core'
import theme from '../../theme'

export const useBudgetStyles = makeStyles({
  root: {
    background: '#F2F2F2',
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '20px 25px',
    width: '100%',
    marginBottom: 25
  },
  selectable: {
    cursor: 'pointer',
    '&:hover': {
      background: 'rgba(184, 217, 238, 0.3)'
    }
  },
  selected: {
    background: 'rgba(184, 217, 238, 1)'
  },
  name: {
    color: '#000',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '11px',
    display: 'flex',
    alignItems: 'center'
  },
  value: {
    color: '#333',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '11px'
  },
  icon: {
    fontSize: '25px',
    color: theme.palette.primary.dark
  },
  addIcon: {
    fontSize: '25px',
    color: theme.palette.success.dark
  },
  paid: {
    background: theme.palette.success.main,
    color: theme.palette.success.contrastText
  },
  payable: {
    background: theme.palette.warning.main,
    color: theme.palette.warning.contrastText
  },
  overdue: {
    background: theme.palette.error.main,
    color: theme.palette.error.contrastText
  }
})

export const useListStyles = makeStyles({
  root: {
    width: '100%',
    height: '100vh',
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '25px',
    background: 'white',
    overflowY: 'auto'
  },
  title: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '36px',
    lineHeight: '42px',
    color: '#333333',
    width: '100%',
    marginBottom: 23
  },
  description: {
    color: '#4F4F4F',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '18px',
    lineHeight: '14px',
    width: '100%',
    marginBottom: 23
  },
  list: {
    width: '100%',
    maxWidth: '1024px',
    margin: '0 auto'
  },
  overflow: {
    overflowY: 'auto',
    maxHeight: '75vh'
  }
})
